import template from '@components/expertise/discovery/discovery.module.scss'
import { IDiscoveryCardsText, IDiscoveryProjectsSection } from '../../discovery.state';
import style from './index.module.scss'
import Image from 'next/image'

interface IDiscoveryProjectsSectionProps {
    section: IDiscoveryProjectsSection;
}

const DiscoveryProjectsSectionComponent = ({ section }: IDiscoveryProjectsSectionProps) => {
    return (
        <section className={`${template.section} ${template.section__block_gray}`}>
            <div className={template.container}>
                <div className={template.costs}>
                    <div className={template.costs__textblock}>
                        <h2 className={template.costs__textblock__title}>
                            {section.title}
                        </h2>
                        <div className={template.costs__textblock__items}>
                            {
                                section.cards.map((item: IDiscoveryCardsText, index: number) => {
                                    return (
                                        <div key={index} className={template.costs__textblock__item}>
                                            <div className={template.costs__textblock__item__title}>
                                                {item.title}
                                            </div>
                                            <div className={template.costs__textblock__item__text}>
                                                {item.text}
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className={template.costs__image}>
                        <Image src={section.imgSrc} layout={'fill'} alt={section.title} />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default DiscoveryProjectsSectionComponent;